import { getModalStore } from './_getModalStore'

const useArrangeVisitModalStore = getModalStore('arrange-visit-modal')

export default useArrangeVisitModalStore
